import { AREAS, DISTRICTS } from '@propertypal/shared/src/constants/housePrices';
import slugify from '@propertypal/shared/src/utils/slugify';
import Link from 'next/link';
import React from 'react';
import PageWrapper from '../layout/PageWrapper';
import { Content, Column, MarketLinks, Title } from './MarketTrendsLinks.style';

const MarketTrendsLinks = () => {
  return (
    <PageWrapper containerStyle={{ margin: '30px 0' }}>
      <Content>
        {DISTRICTS.map((district) => (
          <Column key={district.id}>
            <Title>
              <Link href={`/house-prices/${slugify(district.name)}`}>{district.name}</Link>
            </Title>

            <MarketLinks>
              {AREAS.map((area) => {
                if (area.district !== district.id) return null;

                return (
                  <React.Fragment key={area.id}>
                    <Link href={`/house-prices/${slugify(district.name)}/${slugify(area.name)}`}>{area.name}</Link>
                  </React.Fragment>
                );
              })}
            </MarketLinks>
          </Column>
        ))}
      </Content>
    </PageWrapper>
  );
};

export default MarketTrendsLinks;
